import { IComment } from '@/dealroom-view/chat/types/comment';
export interface IChatState {
  comments: IComment[];
  commentsRead: IComment[];
  loaded: boolean;
}

export enum EChatAction {
  LoadComments = 'loadComments',
  LoadCommentsSuccess = 'loadCommentsSuccess',
  LoadCommentsFailed = 'loadCommentsFailed',
  CreateComment = 'createComment',
  CreateCommentFailed = 'addCommentFailed',
  AddComment = 'addComment',
  DeleteComment = 'deleteComment',
  DeleteCommentFailed = 'deleteCommentFailed',
  SetChatMessages = 'setChatMessages',
  ResetState = 'resetState',
}

export enum EChatMutation {
  SetComments = 'setComments',
  SetLoaded = 'setLoaded',
  SetCommentsRead = 'setCommentsRead',
  SetState = 'setState',
}
